import { createSlice } from "@reduxjs/toolkit";

// Type
import { IInitialState } from "./type";

const initialStateStructureKeyBoard = {
  size: 5,
  number: 0,
  content: [],
  totalPages: 1,
  totalElements: 0
};

const initialStateStructureSearch = {
  size: 10,
  number: 0,
  content: [],
  totalPages: 1,
  totalElements: 0
};

const initialStateGoTo = {
  goTo: 1
};

export const initialStateDataKeyBoard = {
  drugs: initialStateStructureKeyBoard,
  libraries: initialStateStructureKeyBoard,
  compounds: initialStateStructureKeyBoard,
  impurities: initialStateStructureKeyBoard,
  chemicalProbes: initialStateStructureKeyBoard
};

const searchDataKeyBoardGoTo = {
  drugs: initialStateGoTo,
  libraries: initialStateGoTo,
  compounds: initialStateGoTo,
  impurities: initialStateGoTo
};

const initialState: IInitialState = {
  searchDataKeyBoard: {
    type: "",
    searchDataKeyBoardGoTo: searchDataKeyBoardGoTo,
    ...initialStateDataKeyBoard
  },
  type: "",
  value: "",
  message: "",
  loading: false,
  isSearch: false,
  toggleFilter: false,
  isShowTextSearch: false,
  toggleTextSearchData: false,
  recentSearchList: [],
  recentBioSearchList: [],
  historyStructureSearch: [],
  price: {
    value: 0,
    label: ""
  },
  structureSearch: {
    structureType: "compounds",
    structureData: {
      linkers: initialStateStructureSearch,
      compounds: initialStateStructureSearch
    },
    structureGoTo: {
      linkers: initialStateGoTo,
      compounds: initialStateGoTo
    },
    structureLoading: {
      loadingProtac: false,
      loadingLinkers: false,
      loadingCompounds: false
    }
  },

  loadingDrugsTab: false,
  loadingCompoundsTab: false,
  loadingLibrariesTab: false,
  loadingImpuritiesTab: false,
  loadingChemicalProbesTab: false,
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    toggleTextSearchData: (state, action) => {
      state.toggleTextSearchData = action.payload;
    },
    isShowTextSearch: (state, action) => {
      state.isShowTextSearch = action.payload;
    },

    changeToggleFilter: (state) => {
      state.toggleFilter = !state.toggleFilter;
    },

    handlerChangeStructureGoTo: (state, action) => {
      const type = action.payload.type;

      state.structureSearch.structureGoTo[type].goTo = action.payload.goTo;
    },

    handlerChangeSearchKeyBoardGoTo: (state, action) => {
      const type = action.payload.type;

      // @ts-ignore
      state.searchDataKeyBoard.searchDataKeyBoardGoTo[type].goTo = action.payload.goTo;
    },

    handlerChangeSearchKeyBoardSize: (state, action) => {
      const type = action.payload.type;
      // @ts-ignore
      state.searchDataKeyBoard[type].size = action.payload.size;
    },

    handlerChangeStructureSize: (state, action) => {
      const type = action.payload.type;

      state.structureSearch.structureData[type].size = action.payload.size;
    },

    handlerChangeIsSearch: (state, action) => {
      state.isSearch = action.payload;
    },

    handlerChangeTypeStructure: (state, action) => {
      if (state.structureSearch?.structureType) {
        state.structureSearch.structureType = action.payload;
      }
    },

    compoundsSimilarity: (state, action) => {
      if (state.structureSearch) {
        state.structureSearch.structureLoading.loadingCompounds = true;
      }
    },
    compoundsSimilarityError: (state) => {
      if (state.structureSearch) {
        state.structureSearch.structureLoading.loadingCompounds = false;
      }
    },
    compoundsSimilaritySuccess: (state, action) => {
      if (state.structureSearch) {
        state.structureSearch.structureLoading.loadingCompounds = false;
        state.structureSearch.structureData.compounds = action.payload;
      }
    },

    compoundsSubstructure: (state, action) => {
      if (state.structureSearch) {
        state.structureSearch.structureLoading.loadingCompounds = true;
      }
    },
    compoundsSubstructureError: (state) => {
      if (state.structureSearch) {
        state.structureSearch.structureLoading.loadingCompounds = false;
      }
    },
    compoundsSubstructureSuccess: (state, action) => {
      if (state.structureSearch) {
        state.structureSearch.structureLoading.loadingCompounds = false;
        state.structureSearch.structureData.compounds = action.payload;
      }
    },

    compoundsFullfragment: (state, action) => {
      if (state.structureSearch) {
        state.structureSearch.structureLoading.loadingCompounds = true;
      }
    },
    compoundsFullfragmentError: (state) => {
      if (state.structureSearch) {
        state.structureSearch.structureLoading.loadingCompounds = false;
      }
    },
    compoundsFullfragmentSuccess: (state, action) => {
      state.structureSearch.structureLoading.loadingCompounds = false;

      state.structureSearch.structureData.compounds = action.payload;
    },

    linkersSubstructure: (state, action) => {
      state.structureSearch.structureLoading.loadingLinkers = true;
    },
    linkersSubstructureError: (state) => {
      state.structureSearch.structureLoading.loadingLinkers = false;
    },
    linkersSubstructureSuccess: (state, action) => {
      state.structureSearch.structureLoading.loadingLinkers = false;

      state.structureSearch.structureData.linkers = action.payload;
    },

    linkersSimilarity: (state, action) => {
      state.structureSearch.structureLoading.loadingLinkers = true;
    },
    linkersSimilarityError: (state) => {
      state.structureSearch.structureLoading.loadingLinkers = false;
    },
    linkersSimilaritySuccess: (state, action) => {
      state.structureSearch.structureLoading.loadingLinkers = false;

      state.structureSearch.structureData.linkers = action.payload;
    },

    linkersFullfragment: (state, action) => {
      state.structureSearch.structureLoading.loadingLinkers = true;
    },
    linkersFullfragmentError: (state) => {
      state.structureSearch.structureLoading.loadingLinkers = false;
    },
    linkersFullfragmentSuccess: (state, action) => {
      state.structureSearch.structureLoading.loadingLinkers = false;

      state.structureSearch.structureData.linkers = action.payload;
    },

    getStructureSearch: (state, action) => {
      const isClearState = action.payload.isClearState;
      if (isClearState) {
        state.structureSearch.structureData.linkers = initialState.structureSearch.structureData.linkers;
        state.structureSearch.structureData.compounds = initialState.structureSearch.structureData.compounds;
      }
    },
    getStructureSearchError: (state) => {
    },
    getStructureSearchSuccess: (state) => {
    },

    handlerChangePriceCartCompound: (state, action) => {
      state.price = action.payload;
    },

    searchText: (state, action) => {
      state.loading = true;
      state.value = action.payload.value;

      state.type = "";
      state.message = "";
    },
    searchTextError: (state, action) => {
      state.loading = false;
      state.type = action.payload.type;
      state.message = action.payload.message;
    },
    searchTextSuccess: (state, action) => {
      const data = action.payload.data;
      const type = action.payload.type;

      state.loading = false;
      // @ts-ignore
      state.searchDataKeyBoard = {
        ...state.searchDataKeyBoard,
        [type]: data
      };

      state.type = "";
      state.message = "";
    },

    searchTextDrugSuccess: (state, action) => {
      const data = action.payload;

      state.loading = false;
      state.loadingDrugsTab = false;
      // @ts-ignore
      state.searchDataKeyBoard = {
        ...state.searchDataKeyBoard,
        drugs: data
      };

      state.type = "";
      state.message = "";
    },
    searchTextLibrariesSuccess: (state, action) => {
      const data = action.payload;

      state.loading = false;
      state.loadingLibrariesTab = false;
      // @ts-ignore
      state.searchDataKeyBoard = {
        ...state.searchDataKeyBoard,
        libraries: data
      };

      state.type = "";
      state.message = "";
    },
    searchTextCompoundsSuccess: (state, action) => {
      const data = action.payload;

      state.loading = false;
      state.loadingCompoundsTab = false;
      // @ts-ignore
      state.searchDataKeyBoard = {
        ...state.searchDataKeyBoard,
        compounds: data
      };

      state.type = "";
      state.message = "";
    },
    searchTextImpuritiesSuccess: (state, action) => {
      const data = action.payload;

      state.loading = false;
      state.loadingImpuritiesTab = false;
      // @ts-ignore
      state.searchDataKeyBoard = {
        ...state.searchDataKeyBoard,
        impurities: data
      };

      state.type = "";
      state.message = "";
    },
    searchTextChemicalProbesSuccess: (state, action) => {
      const data = action.payload;

      state.loading = false;
      state.loadingChemicalProbesTab = false;
      // @ts-ignore
      state.searchDataKeyBoard = {
        ...state.searchDataKeyBoard,
        chemicalProbes: data
      };

      state.type = "";
      state.message = "";
    },

    searchTextDrugLoadingTab: (state) => {
      state.loadingDrugsTab = true;
    },
    searchTextLibrariesLoadingTab: (state) => {
      state.loadingLibrariesTab = true;
    },
    searchTextCompoundsLoadingTab: (state) => {
      state.loadingCompoundsTab = true;
    },
    searchTextImpuritiesLoadingTab: (state) => {
      state.loadingImpuritiesTab = true;
    },
    searchTextChemicalProbesLoadingTab: (state) => {
      state.loadingChemicalProbesTab = true;
    },

    handlerChangeTypeData: (state, action) => {
      if (state?.searchDataKeyBoard) {
        state.searchDataKeyBoard.type = action.payload;
      }
    },

    handlerChangeStucturePageEbc: (state, action) => {
      if (state.structureSearch?.structureData) {
        // @ts-ignore
        state.structureSearch.structureData.compounds.number = action.payload;
      }
    },
    handlerChangeStucturePageLinkers: (state, action) => {
      if (state.structureSearch?.structureData) {
        // @ts-ignore
        state.structureSearch.structureData.linkers.number = action.payload;
      }
    },

    handlerChangePageLib: (state, action) => {
      if (state.searchDataKeyBoard && state.searchDataKeyBoard.libraries) {
        state.searchDataKeyBoard.libraries.number = action.payload;
      }
    },
    handlerChangePageCompound: (state, action) => {
      if (state.searchDataKeyBoard && state.searchDataKeyBoard.compounds) {
        state.searchDataKeyBoard.compounds.number = action.payload;
      }
    },
    handlerChangePageDrugs: (state, action) => {
      if (state.searchDataKeyBoard && state.searchDataKeyBoard.drugs) {
        state.searchDataKeyBoard.drugs.number = action.payload;
      }
    },
    handlerChangePageImpurities: (state, action) => {
      if (state.searchDataKeyBoard && state.searchDataKeyBoard.impurities) {
        state.searchDataKeyBoard.impurities.number = action.payload;
      }
    },
    handlerChangePageChemicalProbes: (state, action) => {
      if (state.searchDataKeyBoard && state.searchDataKeyBoard.chemicalProbes) {
        state.searchDataKeyBoard.chemicalProbes.number = action.payload;
      }
    },

    historyList: (state, action) => {
      const name = action?.payload?.storeName;
      // @ts-ignore
      state[name] = action?.payload?.data;
    },
    recentSearchListCheck: (state) => {
      const list = localStorage.getItem("recentSearchList") || "[]";
      state.recentSearchList = JSON.parse(list) || [];
    },
    recentBioSearchListCheck: (state) => {
      const list = localStorage.getItem("recentBioSearchList") || "[]";
      state.recentBioSearchList = JSON.parse(list) || [];
    },
    structureSearchCheck: (state) => {
      const list = localStorage.getItem("structureList") || "[]";
      state.historyStructureSearch = JSON.parse(list) || [];
    },
    updateHistoryStructureSearch: (state, action) => {
      state.historyStructureSearch = action.payload;
    },
    deleteItemStructureHistory: (state, action) => {
    }
  }
});

export const {
  isShowTextSearch,
  toggleTextSearchData,

  changeToggleFilter,

  handlerChangeStructureSize,
  handlerChangeSearchKeyBoardSize,

  handlerChangeSearchKeyBoardGoTo,
  handlerChangeStructureGoTo,

  searchTextDrugLoadingTab,
  searchTextLibrariesLoadingTab,
  searchTextCompoundsLoadingTab,
  searchTextImpuritiesLoadingTab,
  searchTextChemicalProbesLoadingTab,

  handlerChangeIsSearch,

  searchText,
  searchTextError,

  searchTextDrugSuccess,
  searchTextCompoundsSuccess,
  searchTextLibrariesSuccess,
  searchTextImpuritiesSuccess,
  searchTextChemicalProbesSuccess,

  historyList,
  recentBioSearchListCheck,

  linkersSimilarity,
  getStructureSearch,
  compoundsSimilarity,
  linkersSubstructure,
  linkersFullfragment,
  structureSearchCheck,
  compoundsFullfragment,
  recentSearchListCheck,
  compoundsSubstructure,
  linkersSimilarityError,
  getStructureSearchError,
  linkersSubstructureError,
  compoundsSimilarityError,
  linkersFullfragmentError,
  linkersSimilaritySuccess,
  getStructureSearchSuccess,
  compoundsFullfragmentError,
  compoundsSubstructureError,
  linkersSubstructureSuccess,
  compoundsSimilaritySuccess,
  deleteItemStructureHistory,
  linkersFullfragmentSuccess,
  compoundsFullfragmentSuccess,
  compoundsSubstructureSuccess,

  handlerChangePageLib,
  handlerChangeTypeData,
  handlerChangePageDrugs,
  handlerChangePageCompound,
  handlerChangePageImpurities,
  handlerChangePageChemicalProbes,

  handlerChangeTypeStructure,
  handlerChangeStucturePageEbc,
  updateHistoryStructureSearch,
  handlerChangePriceCartCompound,
  handlerChangeStucturePageLinkers
} = searchSlice.actions;

export default searchSlice.reducer;
